import * as React from "react";
import { Helmet } from "react-helmet";
import { isPublicPath } from "../../../services/SEO/indexing";

// Lives outside auth guards so the initial HTML and client navigation agree.
export const PageIndexing: React.FC<{ pathname: string }> = ({ pathname }) => (
    <Helmet defer={false}>
        <meta
            name="robots"
            content={process.env.GATSBY_ALLOW_CRAWLERS === "true" && isPublicPath(pathname) ? "index, follow" : "noindex, follow"}
        />
    </Helmet>
);
